"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// strapi cms endpoints
exports.default = {
    BASE_URL: {
        local: 'https://web-cms-staging.lumirental.com',
        development: 'https://web-cms-dev.lumirental.com',
        staging: 'https://web-cms-staging.lumirental.com',
        production: 'https://web-cms.lumirental.com',
    },
    CMS_SERVICE: {
        FAQ: '/faqs?_locale=all',
        ABOUT: '/abouts?_locale=all',
        SERVICES: '/services?locale={locale}',
        HOME: '/home?locale={locale}',
        CITY: '/cities?_locale={locale}',
        AIRPORT: '/airports?_locale={locale}',
        CITY_BRANCH: '/citybranches?_locale={locale}',
        CAR_RENTAL: '/car-rental-page?_locale={locale}',
        MOTORCYCLE: '/motorcycles?_locale={locale}',
        MOTORCYCLE_BRANCH: '/motorcycle-branches?_locale={locale}',
        ALL_AIRPORT_BRANCH: '/all-airports-page?_locale={locale}',
        ALL_CITIES: '/all-cities-page?_locale={locale}',
        ALL_CITY_BRANCH: '/all-cities-branch-page?_locale={locale}',
        ALL_MOTORCYCLE_PAGE: '/all-motorcycle-page?_locale={locale}',
        ALL_UMRAH: '/umrah-page?_locale={locale}',
        CAREERS: '/careers?_locale={locale}',
    },
    REQUEST_ID: {
        CAR_RENTAL_PAGE: 'CAR_RENTAL',
        ALL_AIRPORT_BRANCH_PAGE: 'ALL_AIRPORT_BRANCH',
        ALL_CITIES_PAGE: 'ALL_CITIES',
        ALL_CITY_BRANCH_PAGE: 'ALL_CITY_BRANCH',
        ALL_MOTORCYCLE_PAGE: 'ALL_MOTORCYCLE_PAGE',
        ALL_UMRAH_PAGE: 'ALL_UMRAH',
    },
};
